/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getApiAccount200Schema = z.object({
  username: z.coerce.string(),
  role: z.enum([
    'dipendente',
    'cliente',
    'amministratore',
    'utenteEvoluto',
    'consulente',
  ]),
  name: z.coerce.string(),
  canCreateUnconfirmedCustomers: z.boolean(),
  canCreateUnconfirmedProjects: z.boolean(),
  canViewUnconfirmedCustomer: z.boolean(),
  canViewUnconfirmedProjects: z.boolean(),
  canViewAllCustomers: z.boolean(),
  canMockUsers: z.boolean(),
  cvUpdateRequested: z.boolean(),
  cvLastUpdatedAt: z.string().datetime({ local: true }).nullable().nullish(),
  hasCv: z.boolean(),
  hasCvPreview: z.boolean(),
  dailyHours: z.coerce.number().int(),
  maxDate: z.string().date(),
  minDate: z.string().date(),
  societa: z.array(
    z.object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    }),
  ),
  defaultSocieta: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
});

export const getApiAccountQueryResponseSchema = z.lazy(
  () => getApiAccount200Schema,
);
